import React, {useState} from 'react'
import {Button, Modal, Typography} from 'antd'
import {coinRemark} from './ledgerRemarkFormat'

export default function CoinRemark({record, locale}) {
  const [visible, setVisible] = useState(false)
  const data = coinRemark(record, locale)
  const long = data.summary.length > 48
  return <>
    <span style={{overflowWrap: 'anywhere'}}>{long ? data.summary.slice(0, 48) + '…' : data.summary || '—'}</span>
    {(data.isDoor || long) && <Button type="link" size="small" onClick={() => setVisible(true)}>{data.words.details}</Button>}
    <Modal title={data.words.title} visible={visible} onCancel={() => setVisible(false)} footer={null} destroyOnClose>
      {data.operationId && <><Typography.Text strong>{data.words.operation}</Typography.Text>
        <Typography.Paragraph copyable style={{overflowWrap: 'anywhere'}}>{data.operationId}</Typography.Paragraph></>}
      <Typography.Text strong>{data.words.original}</Typography.Text>
      <Typography.Paragraph copyable style={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere'}}>{data.original || '—'}</Typography.Paragraph>
    </Modal>
  </>
}
